import { inject, Injector } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { AuthRoute } from '../../../../../auth/common/enums/auth-route';
import { AuthService } from '../../../../../auth/common/services/auth.service';
import { ValidationHelper } from '../../../../../common/helpers/validation.helper';
import type { Business } from '../interfaces/business';
import { BusinessService } from '../services/business.service';

export const businessResolver: ResolveFn<Business> = () => {
  const businessService = inject(BusinessService);
  const authService = inject(AuthService);
  const injector = inject(Injector);
  const router = inject(Router);

  return businessService.getBusiness().pipe(
    catchError((response) => {
      ValidationHelper.handleUnexpectedResponse(response, injector, {
        keepOnNavigation: true,
      });

      authService.logout({ redirect: false });

      const urlTree = router.parseUrl(AuthRoute.LOGIN);
      return of(new RedirectCommand(urlTree, { replaceUrl: true }));
    }),
  );
};
